/**
 * @generated SignedSource<<bb7813956698fa41e26caf437fa5368b>>
 * @relayHash db7a79ee3194134302fd2cc2da01380f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 05d1a25330f3cd8aee55c6402834ce3342dfe15073f4a3d92ba25bb04b50c727

import type { ConcreteRequest } from 'relay-runtime';
export type useAllTemplatesQuery$variables = Record<PropertyKey, never>;
export type useAllTemplatesQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly blueprintModuleCompleteKey: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
};
export type useAllTemplatesQuery = {
  response: useAllTemplatesQuery$data;
  variables: useAllTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "usePersonalSpace",
        "value": true
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ],
    "storageKey": "allTemplates(usePersonalSpace:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useAllTemplatesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAllTemplatesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "db7a79ee3194134302fd2cc2da01380f",
    "id": "05d1a25330f3cd8aee55c6402834ce3342dfe15073f4a3d92ba25bb04b50c727",
    "metadata": {},
    "name": "useAllTemplatesQuery",
    "operationKind": "query",
    "text": "query useAllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{blueprintModuleCompleteKey,name}}}"
  }
};
})();

(node as any).hash = "e18a58b29526e42df25c1b26a711b68f";

export default node;
